import { render, staticRenderFns } from "./HelpButton.vue?vue&type=template&id=298ec667"
import script from "./HelpButton.vue?vue&type=script&lang=js"
export * from "./HelpButton.vue?vue&type=script&lang=js"
import style0 from "./HelpButton.vue?vue&type=style&index=0&id=298ec667&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports